import { NgModule, Optional, SkipSelf } from '@angular/core';
import { IconsModule } from 'app/core/icons/icons.module';
import { TranslocoCoreModule } from 'app/core/transloco/transloco.module';

import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { CommonModule } from "@angular/common";
import { AuthModule } from "./auth/auth.module";
import { ApiPrefixInterceptor } from './http/api-prefix.interceptor';
import { DashboardEnvironmentInterceptor } from './http/dashboard-environment.interceptor';

@NgModule({
    imports: [
        IconsModule,
        // TranslocoCoreModule,
        CommonModule,
        // NebulaNgxAuthModule.forRoot(nebulaAuthConfig),
        AuthModule
    ],
    providers: [
        // {
        //     provide: HttpClient,
        //     useClass: HttpService,
        // },
        { provide: HTTP_INTERCEPTORS, useClass: DashboardEnvironmentInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ApiPrefixInterceptor, multi: true },
    ],
})
export class CoreModule {
    /**
     * Constructor
     */
    constructor(
        @Optional() @SkipSelf() parentModule?: CoreModule
    ) {
        // Do not allow multiple injections
        if (parentModule) {
            throw new Error('CoreModule has already been loaded. Import this module in the AppModule only.');
        }
    }
}
